<ng-container *transloco="let t">
  <div class="header-wrapper">
    <mzic-header [homeFocused]="false"></mzic-header>
  </div>

  <section class="not-found-section">
    <div class="mouse-gradient"></div>

    <div class="not-found-container">
      <div class="not-found-content" [@fadeInUp]>
        <div class="error-visual" [@bounceIn]>
          <div class="error-code">
            <span class="digit">4</span>
            <div class="vinyl-record">
              <div class="record-center">
                <div class="center-hole"></div>
              </div>
              <div class="record-grooves">
                <div class="groove" *ngFor="let i of [1, 2, 3, 4, 5]"></div>
              </div>
            </div>
            <span class="digit">4</span>
          </div>
        </div>

        <div class="error-content" [@fadeInUp]>
          <h1 class="error-title">{{ t('lang.title') }}</h1>
          <p class="error-subtitle">{{ t('lang.subtitle') }}</p>
        </div>
      </div>

      <div class="background-elements">
        <div class="gradient-orb orb-1"></div>
        <div class="gradient-orb orb-2"></div>
        <div class="gradient-orb orb-3"></div>
      </div>
    </div>
  </section>
</ng-container>
